<template>
  <div v-if="visible" class="ai-loading-overlay">
    <div class="ai-loading-content">
      <div class="ai-loading-spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
      <div class="ai-loading-text">
        <div class="loading-title">{{ displayTitle }}</div>
        <div class="loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
        <!-- 超时（默认 90s）后提示用户可继续等待或取消生成 -->
        <div v-if="showCancel" class="ai-loading-cancel">
          <p class="cancel-tip">继续等待、取消生成或稍后重试</p>
          <button type="button" class="cancel-btn" @click="$emit('cancel')">取消生成</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiLoading',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '正在加载...'
    },
    // 外部传入的预计时间文本（含"预计时间：XX秒..."），优先使用，避免主副屏随机值不一致
    yujishijian: {
      type: String,
      default: ''
    },
    // 动态阶段文案：按耗时秒数升序 [{ sec, text }]，传了才启用分阶段提示（其他页面不受影响）
    stages: {
      type: Array,
      default: () => []
    },
    // 分阶段计时的统一起点时间戳（主副屏同步用）；不传则以本次显示时刻为准
    startAt: {
      type: Number,
      default: 0
    },
    // 超过该秒数后显示"取消生成"（仅 stages 模式下生效）
    cancelAfter: {
      type: Number,
      default: 90
    }
  },
  data () {
    return {
      startRef: 0,//计时起点（毫秒）
      currentTime: Date.now(),//当前时刻（毫秒），定时器每秒刷新
      timer: null
    }
  },
  computed: {
    isStagesMode () {
      return this.stages && this.stages.length > 0
    },
    elapsedSec () {
      if (!this.startRef) return 0
      return Math.max(0, Math.floor((this.currentTime - this.startRef) / 1000))
    },
    // 命中最后一个 elapsedSec >= sec 的阶段文案
    currentStageText () {
      if (!this.isStagesMode) return this.title
      let text = this.title
      for (let i = 0; i < this.stages.length; i++) {
        if (this.elapsedSec >= this.stages[i].sec) text = this.stages[i].text
      }
      return text
    },
    showCancel () {
      return this.isStagesMode && this.elapsedSec >= this.cancelAfter
    },
    displayTitle () {
      // 分阶段模式：动态切换文案
      if (this.isStagesMode) return this.currentStageText
      if (this.yujishijian) return this.title + this.yujishijian
      // if (this.title.includes('构建专属资产配置方案'))
      //   return this.title + '，预计约35秒~ 请稍后...'
      // else if (this.title.includes('压力测试完成'))
      //   return this.title + '，预计时间：1分钟~ 请稍等...'
      if (this.title.includes('压力测试完成'))
        return this.title + '，预计时间：1分钟~ 请稍等...'
      else return this.title + `，预计时间：${Math.floor(Math.random() * 31 + 30)}秒...`
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.startTimer()
      } else {
        this.stopTimer()
      }
    }
  },
  mounted () {
    if (this.visible) this.startTimer()
  },
  beforeDestroy () {
    this.stopTimer()
  },
  methods: {
    startTimer () {
      // 仅分阶段模式需要按秒刷新文案，普通模式保持原逻辑不额外开定时器
      if (!this.isStagesMode) return
      // 优先使用外部同步起点，保证主副屏文案一致；没有则取本次显示时刻
      this.startRef = this.startAt || Date.now()
      this.currentTime = Date.now()
      this.stopTimer()
      this.timer = setInterval(() => {
        this.currentTime = Date.now()
      }, 1000)
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
}
</script>

<style scoped>
.ai-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.ai-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.ai-loading-spinner {
  position: relative;
  width: 120px;
  height: 120px;
}

.spinner-ring {
  position: absolute;
  border-radius: 50%;
  border: 3px solid transparent;
  animation: spin 1.5s linear infinite;
}

.spinner-ring:nth-child(1) {
  width: 120px;
  height: 120px;
  border-top-color: #3b82f6;
  border-right-color: #3b82f6;
  animation-delay: 0s;
}

.spinner-ring:nth-child(2) {
  width: 90px;
  height: 90px;
  top: 15px;
  left: 15px;
  border-top-color: #8b5cf6;
  border-right-color: #8b5cf6;
  animation-delay: 0.2s;
}

.spinner-ring:nth-child(3) {
  width: 60px;
  height: 60px;
  top: 30px;
  left: 30px;
  border-top-color: #ec4899;
  border-right-color: #ec4899;
  animation-delay: 0.4s;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.ai-loading-text {
  text-align: center;
}

.loading-title {
  font-size: 24px;
  font-weight: 600;
  color: #3b82f6;
  margin-bottom: 20px;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}

.loading-dots {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 10px;
}

.ai-loading-cancel {
  margin-top: 36px;
  text-align: center;
}

.cancel-tip {
  margin: 0 0 14px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.75);
}

.cancel-btn {
  padding: 10px 32px;
  font-size: 15px;
  color: #fff;
  background: rgba(239, 68, 68, 0.85);
  border: 1px solid rgba(239, 68, 68, 0.9);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.cancel-btn:hover {
  background: #ef4444;
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.4);
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3b82f6;
  animation: bounce 1.4s ease-in-out infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}
</style>